import config from '../config/configureEnv';
import {
  ajax,
  getUserAuthDataFromLocalStorage,
} from '../utils';

export default {
  getFPPSurvey: (filters = {}) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/surveys/1/details`, {
      urlParams: { access_token: accessToken },
      data: filters,
    });
  },

  getRecommendation: (sendData) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('POST', `${config.bocaAPIUrl}/user-surveys`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(sendData),
    });
  },

  submitAdditionalQuestions: (sendData, additionalQuestionsSubmissionId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('PATCH', `${config.bocaAPIUrl}/user-surveys/${additionalQuestionsSubmissionId}`, {
      urlParams: { access_token: accessToken },
      data: JSON.stringify(sendData),
    });
  },

  getUserSurveyRecords: (medicalRecordId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/medical-records/${medicalRecordId}/userSurveys`, {
      urlParams: { access_token: accessToken },
    });
  },

  getSubmittedSurveyDetail: (assessmentId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/user-surveys/${assessmentId}/details`, {
      urlParams: { access_token: accessToken },
    });
  },

  getAssessmentPDF: (userSurveyId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    // TODO: The downloading page will crash if server responds an error.
    //  Currently, we just open a new page to prevent the main page from crashing.
    //  Refactor this endpoint if there is a better solution.
    window.open(`${config.bocaAPIUrl}/user-surveys/${userSurveyId}/export?access_token=${accessToken}`, '_blank');
  },

  getAssessmentHistoryPDF: (medicalRecordId) => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    // TODO: The downloading page will crash if server responds an error.
    //  Currently, we just open a new page to prevent the main page from crashing.
    //  Refactor this endpoint if there is a better solution.
    window.open(`${config.bocaAPIUrl}/user-surveys/medical-records/${medicalRecordId}/export?access_token=${accessToken}`, '_blank');
  },

  checkExportPDFPermission: () => {
    const accessToken = getUserAuthDataFromLocalStorage().accessToken;
    return ajax('GET', `${config.bocaAPIUrl}/user-surveys/permission`, {
      urlParams: { access_token: accessToken },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/FPPAPIConnectors.js